export default "__VITE_ASSET__19249866__"